<template>
  <template v-if="fanpage && fanpage.attributes['avatar']">
    <img :alt="fanpage.attributes['name']" class="h-9 w-9 rounded-full inline-block mr-5 mb-8" v-if="fanpage.attributes['avatar']" :src="fanpage.attributes['avatar']">
  </template>
  <AgentAvatar v-else v-bind:agent="agentObject" diameter="34" />
</template>

<script>
import AgentAvatar from '../../agents/AgentAvatar.vue'
import { useMessageAutomationStore } from '@/stores/automation'

export default {
  name: 'AutomationAgent',
  props: ['automationId', 'businessId', 'fanpage'],
  setup() {
    let automationStore = useMessageAutomationStore();
    return { automationStore };
  },
  components: {
    AgentAvatar,
  },
  computed: {
    automation() {
      return this.automationStore.getById(this.automationId);
    },
    agentObject() {
      let name;
      if (this.automation) {
        name = `${this.$t('conversation.autoresponder')}: ${this.automation.attributes['name']}`;
      } else {
        name = this.$t('conversation.autoresponder');
      }
      return {
        'attributes': {'name': name},
        'id': this.businessId,
      }
    }
  },
}
</script>
